// extracted by mini-css-extract-plugin
module.exports = {"icon":"ReportButton-icon-b113545e6c1efd1bcefa980ebfb8ef24","reported":"ReportButton-reported-472e9d1d7bfaa34df44f1ecfd3449a95"};